import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";

export default function MinuteByMinuteHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 item-type-bar-header rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={3} onClick={requestSort ? () => requestSort("played_at") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center justify-content-lg-start">
                        <span className="text-center">Start</span>
                        <span className="col-1">{renderSortIcon("played_at", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl onClick={requestSort ? () => requestSort("artist") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl onClick={requestSort ? () => requestSort("title") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={3} xl={2} onClick={requestSort ? () => requestSort("release_year") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center">Release Year</span>
                        <span className="col-1">{renderSortIcon("release_year", sortConfig)}</span>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
